import { ISvg } from '@/types/ISvg';

export const Sort = (props: ISvg) => {
  const { width = 24, height = 24, color = 'currentColor', className } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 5C3.25 4.03379 4.03379 3.25 5 3.25L19 3.25C19.9662 3.25 20.75 4.03379 20.75 5V7.586C20.75 8.04985 20.566 8.49464 20.2373 8.82333L15.0303 14.0303C14.7374 14.3232 14.2626 14.3232 13.9697 14.0303C13.6768 13.7374 13.6768 13.2626 13.9697 12.9697L19.1767 7.76267C19.224 7.71536 19.25 7.65215 19.25 7.586V5C19.25 4.86221 19.1378 4.75 19 4.75L5 4.75C4.86221 4.75 4.75 4.86221 4.75 5L4.75 7.586C4.75 7.6533 4.77678 7.71636 4.82191 7.76126L4.82333 7.76267L10.0303 12.9697C10.3232 13.2626 10.3232 13.7374 10.0303 14.0303C9.73744 14.3232 9.26256 14.3232 8.96967 14.0303L3.76409 8.82474C3.76382 8.82448 3.76356 8.82422 3.7633 8.82396C3.43293 8.49493 3.25 8.04833 3.25 7.586L3.25 5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 12.75C9.91421 12.75 10.25 13.0858 10.25 13.5L10.25 19.749C10.25 20.0743 10.5558 20.3131 10.8713 20.2343L13.3711 19.6094C13.5935 19.5538 13.75 19.3536 13.75 19.124V13.5C13.75 13.0858 14.0858 12.75 14.5 12.75C14.9142 12.75 15.25 13.0858 15.25 13.5V19.124C15.25 20.0424 14.6245 20.8422 13.7349 21.0646L11.2349 21.6896C9.97243 22.0048 8.75 21.0497 8.75 19.749L8.75 13.5C8.75 13.0858 9.08579 12.75 9.5 12.75Z"
        fill={color}
      />
    </svg>
  );
};
